import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddShopProduct from "./AddShopProduct";
import { getSingleProduct } from "../../../api/product_management/productApi"; // ⚠️ اگر این تابع در productApi وجود نداره، بسازش (GET /products/:id/) یا اسم درستش رو جایگزین کن
import { swalError } from "../../../utils/swalAlert";

// این کامپوننت یک «صفحه» با URL مستقل
// (/panel/manage-shops/:shopId/products/edit/:productId)
// است که فرم مشترک AddShopProduct را در حالت «ویرایش» رندر می‌کند.
//
// نکته: باید مسیر route (مثلاً edit/:id در panelRouter.js) با نامِ پارامتری که
// اینجا با useParams می‌خونیم (productId) هماهنگ باشه. اگر توی روتر اسمش
// ":id" هست، پایین را به همون شکل تغییر بده: const { shopId, id: productId } = useParams();
export default function EditShopProductPage() {
  const { shopId, productId } = useParams();
  const navigate = useNavigate();

  // محصول همیشه تازه از سرور گرفته می‌شود (نه از location.state)، چون state
  // ناوبری در history می‌مونه و بعد از ذخیره ممکنه عکس‌ها/اطلاعات قدیمی
  // نشون داده بشه؛ ضمناً داده‌ی لیست معمولاً لیست کاملِ تصاویر رو نداره.
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const backToProducts = () => navigate(-1);

  useEffect(() => {
    let cancelled = false;
    setProduct(null);
    setLoading(true);

    (async () => {
      try {
        const res = await getSingleProduct(shopId, productId);
        if (!cancelled) setProduct(res.data);
      } catch (err) {
        console.error(err);
        if (!cancelled) {
          swalError({ text: "محصول مورد نظر پیدا نشد." });
          backToProducts();
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, productId]);

  if (loading) {
    return <div className="shop-products">در حال بارگذاری محصول...</div>;
  }

  if (!product) return null;

  return (
    <AddShopProduct
      // با تغییر محصول، فرم از نو ساخته می‌شه تا stateهای اولیه درست ست بشن
      key={product.id}
      shop={{ store_id: shopId }}
      product={product}
      onBack={backToProducts}
      onSubmit={backToProducts}
    />
  );
}
